// extracted by mini-css-extract-plugin
export default {"tinyDivider":"dividers_tinyDivider__i2f3R","tinyDivider__white":"dividers_tinyDivider__white__LP6SJ","tinyDivider__primary":"dividers_tinyDivider__primary__i5Iwq"};